import { ActivatedRoute } from '@angular/router';
import { BaseTabsContainer, TabsContainerService, UserService } from 'yt-ng-framework';
import { Component, OnInit } from '@angular/core';
import { KozDokument } from './koz-dokument';

@Component({
  selector: 'yt-koz-dokument-tabs',
  templateUrl: './koz-dokument-tabs.component.html',
  providers: [
    TabsContainerService
  ]
})
export class KozDokumentTabsComponent extends BaseTabsContainer<KozDokument> implements OnInit {

  constructor(
    public tabsContainerService: TabsContainerService<KozDokument>,
    protected activatedRoute: ActivatedRoute,
    protected userService: UserService
  ) { 
    super(tabsContainerService, activatedRoute, userService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

}
